import React from "react";
import { CheckCircle, Warning, XCircle, Sparkle } from "@phosphor-icons/react";

const ICONS = {
  APPROVED: CheckCircle,
  REQUIRES_DOWNPAYMENT: Warning,
  DENIED: XCircle,
};

const COLORS = {
  ok:      { bg: "#DCEBDD", fg: "#2D5A33", accent: "#7B9D7E" },
  premium: { bg: "#F6EAD2", fg: "#6E5223", accent: "#C5A566" },
  warn:    { bg: "#FAE6CB", fg: "#7A4B12", accent: "#E2B77B" },
  danger:  { bg: "#F4DBDA", fg: "#7A2D2B", accent: "#8B5E5E" },
};

const LABELS = {
  APPROVED: "Aprovado",
  REQUIRES_DOWNPAYMENT: "Entrada obrigatoria",
  DENIED: "Negado",
};

export default function ApprovalDecision({ data }) {
  if (!data) return null;
  const Icon = ICONS[data.decision] || Warning;
  const s = COLORS[data.severity] || COLORS.warn;

  return (
    <div
      className="border p-5 flex items-start gap-4"
      style={{ background: s.bg, color: s.fg, borderColor: s.accent }}
      data-testid="approval-decision"
    >
      {data.severity === "premium" ? (
        <Sparkle size={28} weight="duotone" style={{ color: s.accent, flexShrink: 0 }} />
      ) : (
        <Icon size={28} weight="duotone" style={{ color: s.accent, flexShrink: 0 }} />
      )}
      <div className="flex-1">
        <div className="text-[10px] tracking-[0.2em] uppercase font-bold mb-1" style={{ color: s.accent }}>
          {LABELS[data.decision] || data.decision}
        </div>
        <div className="text-sm leading-relaxed">{data.reason}</div>
        {data.suggested_down_payment > 0 && (
          <div className="text-xs mt-2 opacity-90">
            <strong>Entrada sugerida:</strong> R$ {data.suggested_down_payment.toFixed(2)}
          </div>
        )}
        <div className="text-[10px] tracking-widest uppercase mt-2 opacity-75">
          Score {data.client_score} ({data.client_classification}) · Risco calote {data.risk?.percent}% · Disponivel R$ {data.available_limit?.toFixed(2)}
        </div>
      </div>
    </div>
  );
}
